/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';

import { Colors } from 'src/common/ui/base';
import RouterLink from 'src/components/general/routerLink';
import useMyDayToday from 'src/myDayToday/hooks/useMyDayToday';
import boulderLogo from 'src/nightingale/assets/boulder-logo-white-140x31.png';
import type { Provider } from 'src/shared/stores/resource';
import useRootStore from 'src/stores/useRootStore';
import { patientsQueryParamsForUser } from 'src/util/nav';

const isEnvQA = process.env.REACT_APP_ENVIRONMENT === 'qa';

export const NavLogo = () => {
  const { auth } = useRootStore();
  const user = auth.user as Provider;

  const myDayTodayEnabled = useMyDayToday();

  return (
    <figure data-testid="nav-logo" css={logoStyles}>
      {myDayTodayEnabled ? (
        <RouterLink
          css={logoLinkStyles}
          routeName="myDayToday"
          params={{ id: auth.user?.id ?? '' }}
        >
          <img src={boulderLogo} css={logoGfxStyles} data-testid="boulder-logo-link-mdt" />
          {isEnvQA ? <span css={logoEnvStyles}>QA</span> : null}
        </RouterLink>
      ) : (
        <RouterLink
          css={logoLinkStyles}
          routeName="patients"
          queryParams={patientsQueryParamsForUser(user)}
        >
          <img src={boulderLogo} css={logoGfxStyles} data-testid="boulder-logo-link-patients" />
          {isEnvQA ? <span css={logoEnvStyles}>QA</span> : null}
        </RouterLink>
      )}
    </figure>
  );
};

const logoStyles = css`
  display: block;
  margin: 0;
  padding: 0;
`;

const logoLinkStyles = css`
  color: ${Colors.White};
  display: block;
  padding-right: 20px;
`;

const logoGfxStyles = css`
  width: 70px;
  position: relative;
  top: 2px; // optical vertical align
  @media (max-width: 600px) {
    display: none;
  }
`;

const logoEnvStyles = css`
  font-family: 'Tenor Sans', sans-serif;
  font-size: 1.1em;
  font-weight: bold;
  padding-left: 4px;
  text-transform: uppercase;
`;
